import { api } from '@/lib/api';
import { createFileRoute } from '@tanstack/react-router';
import DadosSoftware from './-component';

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/clientes/hibridos/$id/dados-software/',
)({
  context: ctx => ({
    registrosSoftwareQueryOptions: api.queryOptions(
      'get',
      '/clientes/hibridos/{id}/registros',
      {
        params: { path: { id: ctx.params.id } },
      },
      { staleTime: 1000 * 60 },
    ),
  }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(
      context.registrosSoftwareQueryOptions,
    );
  },
  component: DadosSoftware,
});
